import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="not-found-page">
      <h1>404</h1>
      <p>This page doesn't exist.</p>
      <Link to="/" className="btn btn--primary">
        Go Home
      </Link>
    </div>
  );
}
